import { useLocation } from "react-router";
import { USER_PREFERENCES } from "../constante/localStorage";
import { planogramme, sections } from "../constante/routes";
import { Header } from "../models/Header";
import { Preferences } from "../models/Preferences";
import useLocalStorage from "./useLocalStorage";

// export const useUserPreferences = () => {
//   const location = useLocation();

//   const setUserPreferences = (preferences: Preferences) => {
//     localStorage.setItem(USER_PREFERENCES, JSON.stringify(preferences));
//   };

//   const getUserPreferences = (): Preferences => {
//     const storedUserPreferences = localStorage.getItem(USER_PREFERENCES);
//     return storedUserPreferences
//       ? (JSON.parse(storedUserPreferences) as Preferences)
//       : new Preferences();
//   };

//   const setFilterPreferences = (name: string, value: string) => {
//     const parsedUserPreferences = getUserPreferences();
//     let newUserPreferences: Preferences;

//     const newFilterPreferences = new URLSearchParams(location.search);

//     const filterPreferences: string = newFilterPreferences.toString();

//     value
//       ? newFilterPreferences.set(name, value)
//       : newFilterPreferences.delete(name);

//     switch (location.pathname) {
//       case sections:
//         newUserPreferences = {
//           ...parsedUserPreferences,
//           sectionsFilters: filterPreferences,
//         };
//         break;
//       case planogramme:
//       default:
//         newUserPreferences = {
//           ...parsedUserPreferences,
//           planogrammeFilters: filterPreferences,
//         };
//         break;
//     }

//     setUserPreferences(newUserPreferences);
//   };

//   const setColumnsPreferences = (columnsPreferences: Header[]) => {
//     const parsedUserPreferences = getUserPreferences();
//     let newUserPreferences: Preferences;

//     switch (location.pathname) {
//       case sections:
//         newUserPreferences = {
//           ...parsedUserPreferences,
//           sectionsColumns: columnsPreferences,
//         } as Preferences;
//         break;
//       case planogramme:
//       default:
//         newUserPreferences = {
//           ...parsedUserPreferences,
//           planogrammeColumns: columnsPreferences,
//         } as Preferences;
//         break;
//     }
//     setUserPreferences(newUserPreferences);
//   };

//   return {
//     getUserPreferences,
//     setFilterPreferences,
//     setColumnsPreferences,
//     setUserPreferences: setUserPreferences,
//   };
// };

export const useUserPreferences = () => {
  const location = useLocation();
  const [planogrammeFilters, setPlanogrammeFilters, removePlanogrammeFilters] = useLocalStorage<Preferences["planogrammeFilters"]>("planogrammeFilters", "");
  const [sectionsFilters, setSectionsFilters, removeSectionsFilters] = useLocalStorage<Preferences["sectionsFilters"]>("sectionsFilters", "");
  const [planogrammeColumns, setPlanogrammeColumns, removePlanogrammeColumns] = useLocalStorage<Preferences["planogrammeColumns"]>("planogrammeColumns", undefined);
  const [sectionsColumns, setSectionsColumns, removeSectionsColumns] = useLocalStorage<Preferences["sectionsColumns"]>("sectionsColumns", undefined);

  const setUserPreferences = (preferences: Preferences) => {
    switch (location.pathname) {
      case sections:
        setSectionsFilters(preferences.sectionsFilters);
        setSectionsColumns(preferences.sectionsColumns);
        break;
      case planogramme:
      default:
        setPlanogrammeFilters(preferences.planogrammeFilters);
        setPlanogrammeColumns(preferences.planogrammeColumns);
        break;
    }
  };

  const setFilterPreferences = (name: string, value: string) => {
    const newFilterPreferences = new URLSearchParams(location.search);

    value
      ? newFilterPreferences.set(name, value)
      : newFilterPreferences.delete(name);

    const filterPreferences: string = newFilterPreferences.toString();

    switch (location.pathname) {
      case sections:
        setSectionsFilters(filterPreferences);
        break;
      case planogramme:
      default:
        setPlanogrammeFilters(filterPreferences);
        break;
    }
  };

  const setColumnsPreferences = (columnsPreferences: Header[]) => {
    switch (location.pathname) {
      case sections:
        setSectionsColumns(columnsPreferences);
        break;
      case planogramme:
      default:
        setPlanogrammeColumns(columnsPreferences);
        break;
    }
  };

  return {
    getUserPreferences: () => ({
      planogrammeFilters,
      sectionsFilters,
      planogrammeColumns,
      sectionsColumns,
    }),
    setFilterPreferences,
    setColumnsPreferences,
    setUserPreferences,
  };
};